import React from 'react';
import { RotateCcwIcon, TimerIcon } from 'lucide-react';
type ProblemCardProps = {
  variant: 'blue' | 'gold' | 'navy';
  title: string;
  paragraphs: string[];
  highlight: string;
};
const styles = {
  blue: {
    card: 'border border-line border-l-[5px] border-l-brand bg-white',
    title: 'text-navy',
    body: 'text-ink',
    hl: 'text-brand'
  },
  gold: {
    card: 'border border-line border-l-[5px] border-l-gold bg-white',
    title: 'text-navy',
    body: 'text-ink',
    hl: 'text-goldDark'
  },
  navy: {
    card: 'bg-navy',
    title: 'text-white',
    body: 'text-white',
    hl: 'text-gold'
  }
};
export function ProblemCard({
  variant,
  title,
  paragraphs,
  highlight
}: ProblemCardProps) {
  const s = styles[variant];
  const Icon = variant === 'gold' ? RotateCcwIcon : variant === 'navy' ? TimerIcon : null;
  return <article className={`rounded-md px-4 py-3.5 md:px-4 md:py-4 ${s.card}`} data-id="element-103" data-mp="6til38asdq8y">
      <h2 className={`font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] md:text-[24px] ${s.title}`} data-id="element-104" data-mp="6vd42h2hz8ae">
        {Icon && <Icon className="mr-2 inline h-5 w-5 -translate-y-0.5 text-gold md:h-6 md:w-6" strokeWidth={2.5} aria-hidden data-id="element-105" data-mp="1dvh3kcv7555w" />}
        {title}
      </h2>
      <p className={`mt-1 text-[14px] leading-[1.37] md:text-[15px] ${s.body}`} data-id="element-106" data-mp="191w38e64rz3j">{paragraphs.join(' ')}</p>
      <p className={`mt-1.5 font-heading text-[12px] font-extrabold uppercase leading-tight md:text-[14px] ${s.hl}`} data-id="element-107" data-mp="14zr9zgjlh4hf">
        {highlight}
      </p>
    </article>;
}